import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { getDashboardStats } from '../services/api';
import './Dashboard.css';

function Dashboard() {
  const { t } = useTranslation();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const loadStats = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getDashboardStats();
      setStats(data);
    } catch (err) {
      setError(err.message || t('admin.dashboard.errors.load_stats_failed'));
    } finally {
      setLoading(false);
    }
  }, [t]);

  useEffect(() => {
    loadStats();
  }, [loadStats]);

  if (loading) {
    return <div className="loading">{t('admin.dashboard.loading')}</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  return (
    <div className="dashboard">
      <h2>{t('admin.dashboard.title')}</h2>
      <div className="stats-grid">
        <div className="stat-card">
          <h3>{t('admin.dashboard.cards.users')}</h3>
          <p className="stat-value">{stats?.total_users || 0}</p>
        </div>
        <div className="stat-card">
          <h3>{t('admin.dashboard.cards.licenses')}</h3>
          <p className="stat-value">{stats?.total_licenses || 0}</p>
        </div>
        <div className="stat-card">
          <h3>{t('admin.dashboard.cards.active_licenses')}</h3>
          <p className="stat-value">{stats?.active_licenses || 0}</p>
        </div>
        <div className="stat-card">
          <h3>{t('admin.dashboard.cards.pending_registrations')}</h3>
          <p className="stat-value">{stats?.pending_registrations || 0}</p>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;






